"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ChangePasswordInputGroup_1 = __importDefault(require("./ChangePasswordInputGroup"));
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../../../shared/typography");
const form_1 = require("../../../../molecules/form/form");
const buttons_1 = require("../../../../atoms/buttons");
const hooks_1 = require("../../../../shared/hooks");
exports.default = ({ translations, offline, onSubmit, onClose }) => {
    const [values, onChange] = (0, hooks_1.useForm)({
        oldPassword: "",
        newPassword: "",
        repeatedPassword: ""
    });
    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onSubmit(values);
    };
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { onClick: (e) => e.stopPropagation(), children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(typography_1.H2, { children: translations.title }, void 0) }, void 0), (0, jsx_runtime_1.jsxs)(form_1.Form, { variant: "vertical", method: "POST", onSubmit: handleSubmit, children: [(0, jsx_runtime_1.jsx)(ChangePasswordInputGroup_1.default, { translations: translations, onChange: onChange, disabled: offline }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "secondary", type: "button", onClick: onClose, children: translations.backToLink }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "primary", disabled: offline, type: "submit", children: translations.btnLabel }, void 0)] }, void 0)] }, void 0)] }, void 0));
};
const Wrapper = styled_components_1.default.div `
  h2 {
    margin-bottom: 0;
  }

  & > div:first-of-type {
    border-bottom: ${({ theme }) => `1px solid ${theme.colors.silverBase}`};
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};
  }

  form {
    margin: 0;
    padding: ${({ theme }) => `0 ${theme.spacings.xl}`};
  }

  form > div:last-of-type {
    border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
    display: flex;
    justify-content: space-between;
    margin-bottom: ${({ theme }) => theme.spacings.xs};
    padding-top: ${({ theme }) => theme.spacings.m};
  }

  button:first-of-type {
    margin-right: ${({ theme }) => theme.spacings.m};
  }
`;
//# sourceMappingURL=ChangePassword.js.map